import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { RadioButtonsModule } from '../radio-buttons/radio-buttons.module';
import { ScalesComponent } from './scales.component';


@NgModule({
  declarations: [
    ScalesComponent,
  ],
  exports: [
    ScalesComponent,
  ],
  imports: [
    CommonModule,
    RadioButtonsModule,
    PipesModule,
  ]
})
export class ScalesModule { }
